import { handleError } from '@services/SettingAxios';
import axios from 'axios';

class ServiceLibs {
  // ------- Aplaut -------
  async getWidget(rn: number): Promise<string> {
    return axios
      .get(
        `https://w-api2.aplaut.io/widgets/v2/render?authentication_token=sfB2AEv15FUhVJn46JP3&theme_id=default&context=product&context_id=${rn}&widget_id=inline-rating`,
        {
          responseType: 'text',
        },
      )
      .then(({ data }) => data)
      .catch(error => handleError(error));
  }

  async getReviewsWidget(rn: number): Promise<number | null> {
    const data = await this.getWidget(rn);
    try {
      if (data) {
        const result = data.match(/\d+ (отзывов|отзыва|отзыв)/);
        return result ? parseInt(result[0].replace('/(отзывов|отзыва|отзыв)/', '')) : null;
      } else {
        return null;
      }
    } catch (e) {
      console.log(e);
    }
  }
  // --------------------
}

const serviceLibsInstance = new ServiceLibs();

export default serviceLibsInstance;
